import { OrderResponseDto } from '@planning/app/api'
import {
  extractSubFormData,
  FieldStore,
  ISubFormStore,
  required,
  validateSubForm,
} from '@tom-ui/utils'

export type StowagePositionFormData = {
  bay?: number
  row?: number
  tier?: number
}

export const createStowagePositionFormDataFromOrderResponse = (
  order?: OrderResponseDto,
): StowagePositionFormData => {
  return {
    bay: order?.stowagePosition?.bay,
    row: order?.stowagePosition?.row,
    tier: order?.stowagePosition?.tier,
  }
}

export class StowagePositionSubFormStore implements ISubFormStore<StowagePositionFormData> {
  bay: FieldStore<number | undefined | string>
  row: FieldStore<number | undefined | string>
  tier: FieldStore<number | undefined | string>

  constructor() {
    this.bay = new FieldStore<number | undefined | string>(undefined, required())
    this.row = new FieldStore<number | undefined | string>(undefined, required())
    this.tier = new FieldStore<number | undefined | string>(undefined, required())
  }

  setValues(data?: StowagePositionFormData) {
    this.bay.setValue(
      data?.bay !== undefined && data?.bay !== null ? String(data.bay).padStart(3, '0') : '',
    )
    this.row.setValue(
      data?.row !== undefined && data?.row !== null ? String(data.row).padStart(2, '0') : '',
    )
    this.tier.setValue(
      data?.tier !== undefined && data?.tier !== null ? String(data.tier).padStart(2, '0') : '',
    )
  }

  validate = () => {
    return validateSubForm(this)
  }

  get data() {
    return extractSubFormData(this)
  }
}
